import React from "react";

import { MediaImage } from "@app/scripts/react-general-components/MediaImage";
import { useShopifyProduct } from "@app/scripts/react-hooks/shopify";
import { ProductPrice } from "@app/scripts/react-product/components/ProductPrice";

import type { NormalisedProduct } from "@app/scripts/types";

type Props = {
  product: NormalisedProduct;
  parentProduct?: NormalisedProduct;
};

export const ProductMoreColorsProduct: React.FC<Props> = ({ product, parentProduct }) => {
  const { colorFromTitle, url, title } = useShopifyProduct({ product });
  const isCurrentProduct = parentProduct?.id && product?.id?.toString()?.includes(parentProduct.id?.toString());

  return (
    <a href={url} title={title} className="product-more-colors__product">
      <div className="product-more-colors__product-details">
        <div className={`${isCurrentProduct ? "active" : ""} product-more-colors__product-image`}>
          {product.media?.[0] ? (
            <MediaImage media={product.media?.[0]} />
          ) : (
            <div className="product-more-colors__product-placeholder" />
          )}
        </div>
        <span className="product-more-colors__product-color">{colorFromTitle}</span>

        <ProductPrice product={product} />
      </div>
    </a>
  );
};
